// extracted by mini-css-extract-plugin
export var style_component = "XTeamLogo-module--style_component--04d84";